import { render, staticRenderFns } from "./advancedMaterial.vue?vue&type=template&id=1a8ba603&scoped=true"
import script from "./advancedMaterial.vue?vue&type=script&lang=js"
export * from "./advancedMaterial.vue?vue&type=script&lang=js"
import style0 from "./advancedMaterial.vue?vue&type=style&index=0&id=1a8ba603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ba603",
  null
  
)

export default component.exports